import { PointerSensor, KeyboardSensor, useSensor, useSensors } from '@dnd-kit/core'
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

export const useBuilderSensors = () => useSensors(
  useSensor(PointerSensor, { activationConstraint: { distance: 4 } }),
  useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
)

export const sortableStyle = ({ transform, transition, isDragging }) => ({
  transform: CSS.Transform.toString(transform),
  transition,
  opacity: isDragging ? 0.5 : 1,
})

export const dragEndIds = ({ active, over }) => (over && active.id !== over.id ? { activeId: active.id, overId: over.id } : null)
